import { Injectable, inject } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { map, take } from 'rxjs/operators';
import { filter, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../state/app.state';
import { selectTranslationsForLang } from '../admin/translations/state/translations.selectors';
import { loadTranslations } from '../admin/translations/state/translations.actions';
import { flattenTranslations } from './flatten-translations';

@Injectable({
  providedIn: 'root',
})
export class CustomTranslateLoaderService implements TranslateLoader {
  private readonly store = inject<Store<AppState>>(Store);

  public getTranslation(lang: string): Observable<Record<string, string>> {
    this.store.dispatch(loadTranslations());

    return this.store.select(selectTranslationsForLang(lang)).pipe(
      filter(
        (data): data is Record<string, Record<string, string>> =>
          !!data && Object.keys(data).length > 0
      ),
      take(1),
      map((nsMap) => flattenTranslations('', nsMap))
    );
  }
}
